/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Iban } from "./Iban";
import * as t from "io-ts";

// required attributes
const IbansR = t.interface({
  ibans: t.readonlyArray(Iban, "array of Iban")
});

// optional attributes
const IbansO = t.partial({});

export const Ibans = t.intersection([IbansR, IbansO], "Ibans");

export type Ibans = t.TypeOf<typeof Ibans>;
